export default __webpack_public_path__ + "static/media/uploader-animas-3.de6edb05.png";